export const hotelShow: any = {
  localGuide: "周辺ガイド",
  localInformation: "周辺情報",
  roomNotAvailableMessage: "指定の日程で空きはございませんでした",
  hotelFacilitiesAndServices: "ホテルの設備 / サービス",
  hotelPolicies: "ホテルのポリシー",
  facilitiesAndServices: "設備 / サービス",
  serviceChargesAndOptionalFees: "サービス料/オプションの追加料金",
};
